exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!../../../styles/typography.css"), undefined);

// module
exports.push([module.id, ".Tooltip--tooltip--11k8T{display:block;background-color:#fff;border:solid;pointer-events:none;position:absolute;border-radius:4px;opacity:.75}.Tooltip--content--3kiTD{display:flex;align-items:center;justify-content:space-between;width:100%;padding:5px 10px;box-sizing:border-box}.Tooltip--content--3kiTD span{width:100%}.Tooltip--title--3FG33{background-color:var(--tooltip-title-bg)}.Tooltip--tail--3IQ2Y{width:0;height:0;border-style:solid;border-color:transparent;position:absolute}", ""]);

// exports
exports.locals = {
	"tooltipTitleBg": "var(--tooltip-title-bg)",
	"tooltip": "Tooltip--tooltip--11k8T " + require("-!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!../../../styles/typography.css").locals["defaultSize"] + "",
	"content": "Tooltip--content--3kiTD",
	"title": "Tooltip--title--3FG33 " + require("-!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!../../../styles/typography.css").locals["mediumContrastText"] + " Tooltip--content--3kiTD",
	"tail": "Tooltip--tail--3IQ2Y"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!./~/postcss-loader!./src/components/common/tooltips/Tooltip.css
 ** module id = 6
 ** module chunks = 0
 **/